import { z } from 'zod'

/**
 * Stable `code` values returned in JSON `{ code, message? }` for player HTTP 401/403 responses.
 * @see https://github.com/lucimark/lucimark/issues/247
 */
export const PLAYER_AUTH_ERROR_CODES = [
  'invalid_headers',
  'unauthorized',
  'tenant_not_found',
  'invalid_player_id',
  'invalid_player_registration',
  'invalid_tenant_id',
  'unauthorized_connection',
  'invalid_secret',
  'invalid_bearer_token',
  'not_authenticated',
  'player_id_mismatch',
  'player_not_found_in_tenant',
  'not_authorized',
  'invalid_authentication',
  'tenant_not_ready',
  'player_not_registered',
  'invalid_player_jwt'
] as const

export type TPlayerAuthErrorCode = (typeof PLAYER_AUTH_ERROR_CODES)[number]

export const playerAuthErrorBodySchema = z.object({
  code: z.string(),
  message: z.string().optional()
})

export type TPlayerAuthErrorBody = z.infer<typeof playerAuthErrorBodySchema>

export function parsePlayerAuthErrorBody(data: unknown): TPlayerAuthErrorBody | null {
  const parsed = playerAuthErrorBodySchema.safeParse(data)
  return parsed.success ? parsed.data : null
}
